import React, { Component, type JSX } from 'react';
import { DBBoolean, SearchBijlesResult } from './SearchBijles.model';

interface ComponentProps{
  props: SearchBijlesResult;
  product: string;
}

export class SearchBijlesItem extends Component<ComponentProps> {
    
  public render(): JSX.Element {
    const { props, product } = this.props;

    const is_hub: boolean = props.timberpost && props.timberpost.is_hub === DBBoolean.TRUE;
    
    const contact_aanvragen_button_text: string = $('#contact_aanvragen_button_text').text();

    const handleOpenModal = (): void => {
      //@ts-ignore
      $('.contact_aanvragen').modal('show');
      $('.form_loc_name').text(props.loc_naam);
      $('.location_id_field input').val(props.id_locatie);
      $(`.location_products_field select option[value="${product}"]`).prop('selected', true);
      $('.location_products_field').hide();
    };

    // these values may we need later if we revive the Google Maps feature
    const loc_img = {
      backgroundImage: 'url(' + props.thumbnail_url + ')',
    };
    const loc_logo = {
      backgroundImage: 'url(' + props.label_logo_url + ')',
    };
    const info_box = '<div><strong>' + props.loc_naam + '</strong><br/>'
            + props.loc_straat + ' ' + props.loc_nr + '<br/>'
            + props.loc_postcode + ' ' + props.loc_stad + '</div>';

    let list_class = 'list-item maps-lat-lng';

    const locAdress = props.loc_straat + ' ' + props.loc_nr;
    const org_style = { display: 'none' };

    //if (listItem > 3) {
    //  list_class += ' list-item--invisible';
    //}

    if (is_hub === true){
      list_class += ' list-item--featured';
    }

    return (
      <li itemScope itemType="https://schema.org/LocalBusiness" className={list_class}
        data-lat={props.loc_lat}
        data-long={props.loc_long}
        data-infobox={info_box}>
        <meta itemProp="name" content={props.loc_naam}/>
        <meta itemProp="latitude" content={props.loc_lat}/>
        <meta itemProp="longitude" content={props.loc_long}/>
        <div itemProp="address" itemScope itemType="https://schema.org/PostalAddress">
          <meta itemProp="streetAddress" content={locAdress}/>
          <meta itemProp="postalCode" content={props.loc_postcode}/>
          <meta itemProp="addressLocality" content={props.loc_stad}/>
        </div>
        <meta itemProp="telephone" content={props.loc_telefoon}/>
        <div className="list-item__content">
          <a className="list-item__img" href={props.Permalink} style={loc_img}>
            {![
              'https://mijnskoleo.nl/files/images/label/1/logo.png',
              'https://mijnskoleo.nl/files/factuur-logo-labels/8/logo.png',
            ].includes(props.label_logo_url) && (
              <>
                <meta itemProp="logo" content={props.label_logo_url}/>
                <span className="list-item__logo" style={loc_logo}/>
              </>
            )}
            {props.Distance && (
              <span className="list-item__distance">
                {props.Distance} km
              </span>
            )}
          </a>
          <div className="list-item__inner">
            <a href={props.Permalink} className="list-item__headings">
              <h4 className="list-item-headings__header">
                <span className="fist_name"> {props.loc_name_short_first} </span>
                <span className="second_name"> {props.loc_name_short_second} </span>
              </h4>
            </a>
            {is_hub
              ? <span className="list-item__featured-label">
                Eigen locatie - voor iedereen toegankelijk
              </span>
              : <span className="list-item__school-label">
                Schoollocatie – vraag naar de mogelijkheden
              </span>
            }
            <div className="list-item-btn-wrp">
              {product !== 'hub' && (
                <button
                  className="list-item__btn list-item__btn--red btn btn-block contact_aanvragen_button"
                  onClick={handleOpenModal}
                >
                  {contact_aanvragen_button_text}
                </button>
              )}
              <a itemProp="url" href={props.Permalink}
                className="link_locatie">
                                Over deze locatie <i className="fa-regular fa-arrow-right"></i>
              </a>
            </div>
            <meta itemProp="priceRange" content="Not Applicable"/>
            <span style={org_style} itemProp="parentOrganization" itemScope itemType="https://schema.org/Organization">
              <a itemProp="url" href="https://lyceo.nl/"><span itemProp="name">Lyceo</span>
              </a>
            </span>
          </div>
        </div>
      </li>
    );
  }
}
